var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.salesNetworkUser)?_c('user-sales-network',{attrs:{"sales-network-user":_vm.salesNetworkUser}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }